<template>
  <div>
    <NavigationBar
      titel="Abfrageart anlegen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        @submit.prevent="createItem"
        ref="form"
        v-model="helpers.formIsValid"
      >
        <request-type-editor
          v-model="requestType"
          mode="new"
        ></request-type-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { AVAILABILITY } from "@/store/modules.js";
import { CREATE_REQUEST_TYPE } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import RequestTypeEditor from "@/components/availability/requests/RequestTypeEditor.vue";

export default {
  name: "availability-config-tab-request-types-request-type-new",
  components: {
    NavigationBar,
    RequestTypeEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus-circle",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],
      requestType: {
        title: "",
        shortTitle: "",
        description: "",
        color: "#F44336",
        sortKey: Number,
      },
      helpers: {
        formIsValid: false,
      },
    };
  },
  computed: {
    newSortKey() {
      return this.$store.state.availability.requestTypes.length + 1;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.requestType.sortKey = this.newSortKey;
    },
    validate() {
      this.$refs.form.validate();
    },
    createItem() {
      this.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${AVAILABILITY}${CREATE_REQUEST_TYPE}`, {
          organizationId: this.$route.params.organizationId,

          title: this.requestType.title,
          shortTitle: this.requestType.shortTitle,
          description: this.requestType.description,
          color: this.requestType.color,
          sortKey: this.requestType.sortKey,
        });
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
  },
};
</script>

<style></style>
